import Icon from '../components/Icon.vue'

Icon.register({
  'search-plus': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M304 192V224C304 230.6 298.6 236 292 236H236V292C236 298.6 230.6 304 224 304H192C185.4 304 180 298.6 180 292V236H124C117.4 236 112 230.6 112 224V192C112 185.4 117.4 180 124 180H180V124C180 117.4 185.4 112 192 112H224C230.6 112 236 117.4 236 124V180H292C298.6 180 304 185.4 304 192zM505 476.7L476.7 505C467.3 514.4 452.1 514.4 442.8 505L343 405.3C338.5 400.8 336 394.7 336 388.3V372C300.7 399.6 256.3 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208C416 256.3 399.6 300.7 372 336H388.3C394.7 336 400.8 338.5 405.3 343L505 442.7C514.3 452.1 514.3 467.3 505 476.7zM344 208C344 132.8 283.2 72 208 72S72 132.8 72 208 132.8 344 208 344 344 283.2 344 208z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/search-plus.js
// module id = 5gLO
// module chunks = 144